import { render } from "./ThongBaoHuyThanhToan.vue?vue&type=template&id=c4fab746&scoped=true"
import script from "./ThongBaoHuyThanhToan.vue?vue&type=script&lang=js"
export * from "./ThongBaoHuyThanhToan.vue?vue&type=script&lang=js"

import "./ThongBaoHuyThanhToan.vue?vue&type=style&index=0&id=c4fab746&lang=scss&scoped=true"
import "./ThongBaoHuyThanhToan.vue?vue&type=style&index=1&id=c4fab746&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fab746"]])

export default __exports__